export const INSURANCE = {
  HEALTH_INSURANCE: 'group-health-insurance-v2',
  TRAVEL_INSURANCE: 'group-travel-insurance-v2',
  GIG_INSURANCE: 'gig-worker-health-insurance-v2',
  ELECTRONICS_INSURANCE: 'electronic-device-insurance-v2',
}
